<template>
    <toolbar-option>
        <template slot="primary">
            <calendar-facet-title-color
                :value="title.color"
                @input="onColorInput"
            />
            <calendar-facet-title-font-family
                :value="title.font"
                @input="onFontInput"
            />
            <calendar-facet-title-font-size
                :value="title.size"
                @input="onFontSizeInput"
            />
            <calendar-facet-title-font-style
                :value="title.style"
                @input="onFontStyleInput"
            />
            <calendar-facet-title-font-weight
                :value="title.weight"
                @input="onFontWeightInput"
            />
            <calendar-facet-title-alignment
                :value="title.alignment"
                @input="onAlignmentInput"
            />
            <calendar-facet-title-text-transform
                :value="title.textTransform"
                @input="onFontTextTransformInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-title';

export default {
    name: 'calendar-facet-title',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Title Options',
            message: '',
            value: '',
            checked: false,
            title: {
                color: '',
                font: '',
                weight: '',
                size: '',
                style: '',
                alignment: '',
            },
        };
    },

    methods: {
        onColorInput(cssClass) {
            this.title.color = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleColorClass = cssClass;
        },

        onFontInput(cssClass) {
            this.title.font = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleFontClass = cssClass;
        },

        onFontSizeInput(cssClass) {
            this.title.size = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleFontSizeClass = cssClass;
        },

        onFontStyleInput(cssClass) {
            this.title.style = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleFontStyleClass = cssClass;
        },

        onFontWeightInput(cssClass) {
            this.title.weight = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleFontWeightClass = cssClass;
        },

        onAlignmentInput(value) {
            this.title.alignment = value;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].titleAlignment = value;
        },

        onFontTextTransformInput(value) {
            this.title.textTransform = value;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.title);
            this.selectedElements[0].textTransform = value;
        },

        onSelectedElement() {
            this.title = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.title;
        },
    },
};
</script>
